import ResourceCategoryLibrary from "../components/ResourceCategoryLibrary/ResourceCategoryLibrary";
import { WellKnownLearningMaterialCategories } from "UIPalette/LearningMaterials/wellKnownLearningMaterials";
import { useTranslation } from "react-i18next";
import { ResourceViewer } from "../components/ResourceViewer/ResourceViewer";

export const ViewArticle = () => <ResourceViewer pageTitle="pageTitle.resources.articles.article" />;

export const Article = () => {
  const { t } = useTranslation();

  return <ResourceCategoryLibrary category={WellKnownLearningMaterialCategories.articles} pageTitle={t("pageTitle.resources.articles.home")} />;
};
